import React from 'react'
import { Modal, Button } from 'antd'

const OkModal = ({message, visible, handleOk, title }) => (
  <Modal
    visible={visible}
    onOk={handleOk}
    footer={(
      <Button onClick={handleOk} type="primary" 
        className="btn-wide-md">
        Ok
      </Button>
    )}
    title={title}
    closable={false}
  >
    <p>{message}</p>
  </Modal>
)

export default OkModal
